import type { Project } from "../interfaces/Project";

const DEFAULT_MAP_CENTER = { lat: 39.8283, lng: -98.5795 };

export function projectHasMapCoords(p: Project): boolean {
    const lat = p.latitude;
    const lng = p.longitude;
    return typeof lat === "number" && typeof lng === "number" && Number.isFinite(lat) && Number.isFinite(lng);
}

export function getDefaultMapCenter(): { lat: number; lng: number } {
    return { ...DEFAULT_MAP_CENTER };
}
